module.exports = __webpack_public_path__ + "static/media/cover.e1ccf754.webp";